import { GetterTree } from 'vuex';
import AppState from '@/store/modules/app/types/AppState';
import IRootState from '@/store/types/IRootState';

const getters: GetterTree<AppState, IRootState> = {
  version: (state) => {
    return state.version;
  },

  locale: (state) => {
    return state.locale;
  },
};

export default getters;
